import React, { useState, useEffect, useRef } from 'react';
import { useLanguage } from '../../store/languageContext';
import Header from '../common/Header';
import { motion } from 'framer-motion'
import translate from '../../utils/translation';
const FAQ = () => {
    const sectionRef = useRef(null);
    const { language, setNavColor } = useLanguage();
    const [activeIndex, setActiveIndex] = useState(0);
    useEffect(() => {
        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) {
                    setNavColor('white');
                }
            },
            {
                threshold: 0.1,
                rootMargin: '-50px 0px -20% 0px',
            }
        );

        const currentRef = sectionRef.current;
        if (currentRef) {
            observer.observe(currentRef);
        }

        return () => {
            if (currentRef) {
                observer.unobserve(currentRef);
            }
        };
    }, [setNavColor]);
    const faqs = [
        {
            question: translate[language]['faqQuestion1'],
            answer: translate[language]['faqAnswer1']
        },
        {
            question: translate[language]['faqQuestion2'],
            answer: translate[language]['faqAnswer2']
        },
        {
            question: translate[language]['faqQuestion3'],
            answer: translate[language]['faqAnswer3']
        },
        {
            question: translate[language]['faqQuestion4'],
            answer: translate[language]['faqAnswer4']
        },
        {
            question: translate[language]['faqQuestion5'],
            answer: translate[language]['faqAnswer5']
        },
    ];
    return (
        <section ref={sectionRef} className="landing-section flex flex-col bg-[#111] px-4 sm:px-6">
            <div className="container mx-auto">
                <Header text={translate[language]['faqHeader']} theme="white" />
                <div className="flex text-white flex-col md:flex-row">
                    <div className='hidden md:block md:w-1/3' />
                    <div className="w-full md:w-2/3 flex flex-col justify-between items-start md:items-center">
                        <div className='w-full md:w-4/5 lg:w-1/2'>
                            <motion.h2
                                initial={{ y: 100, opacity: 0 }}
                                whileInView={{ y: 0, opacity: 1 }}
                                transition={{ duration: 0.5, delay: 0.2, ease: 'easeOut' }}
                                viewport={{ once: true }}
                                className='text-3xl sm:text-4xl md:text-5xl lg:text-[60px] leading-tight lg:leading-[60px] font-semibold mb-4'>
                                {translate[language]['faqTitle1']}
                            </motion.h2>
                            <motion.p
                                initial={{ y: 50, opacity: 0 }}
                                whileInView={{ y: 0, opacity: 1 }}
                                transition={{ duration: 0.5, delay: 0.4, ease: 'easeOut' }}
                                viewport={{ once: true }}
                                className='opacity-[0.5] text-sm sm:text-base'>
                                {translate[language]['faqTitle2']}
                            </motion.p>
                        </div>
                    </div>
                </div>
                <motion.div
                    initial={{ y: 100, opacity: 0 }}
                    whileInView={{ y: 0, opacity: 1 }}
                    transition={{ duration: 0.7, delay: 0.2, ease: 'easeOut' }}
                    viewport={{ once: true }}
                    className='w-full text-white mt-8 sm:mt-12'>
                    {faqs.map((faq, index) => (
                        <div key={index} className={`font-semibold py-4 sm:py-6 border-b border-[#cccccc21] grid grid-cols-1 sm:grid-cols-4 md:grid-cols-3 gap-2 sm:gap-4`}>
                            <div className='sm:col-span-1'>
                                <span className="uppercase flex-1 text-base sm:text-lg font-thin text-[#cccccc69]">0{index + 1}</span>
                            </div>
                            <div
                                onClick={() => setActiveIndex(index)}
                                className={`w-full flex flex-col justify-between items-start sm:items-center pb-2 sm:pb-[15px] ${language === 'ar' ? 'text-right' : 'text-left'} cursor-pointer sm:col-span-3 md:col-span-2 relative`}
                            >
                                <span className={`absolute top-0 ${language === 'ar' ? 'left-0' : 'right-0'} rounded-full size-8 sm:size-[40px] flex justify-center items-center bg-[#cccccc69] text-[#589EEE] leading-0 text-base sm:text-lg duration-500 ${activeIndex === index ? 'rotate-[45deg]' : ''}`}>
                                    +
                                </span>
                                <div className='w-full pr-10 sm:pr-12 md:w-4/5 lg:w-1/2'>
                                    <span className="capitalize flex-1 text-lg sm:text-xl md:text-2xl">
                                        {faq.question}
                                    </span>
                                    {activeIndex === index && (
                                        <motion.div
                                            initial={{ height: 0, opacity: 0 }}
                                            animate={{ height: 'auto', opacity: 1 }}
                                            exit={{ height: 0, opacity: 0 }}
                                            transition={{ duration: 0.5 }}
                                            className="overflow-hidden mt-2"
                                        >
                                            <p className='opacity-50 text-sm sm:text-base'>{faq.answer}</p>
                                        </motion.div>
                                    )}
                                </div>
                            </div>
                        </div>
                    ))}
                </motion.div>
            </div>
        </section>
    );
};

export { FAQ };